import React from "react";
import { Route, Switch } from "react-router-dom";
import { DupFlowStepFour } from "../../layouts/dupFlow/steps/DupFlowStepFour";
import { DupFlowStepOne } from "../../layouts/dupFlow/steps/DupFlowStepOne";
import { DupFlowStepThree } from "../../layouts/dupFlow/steps/DupFlowStepThree";
import { DupFlowStepTwo } from "../../layouts/dupFlow/steps/DupFlowStepTwo";
import { PORTALTHIRD_BASE_URL } from "../../constants/constants";

const DupFlow = (props) => (
  <Switch>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step1Path.value}`}>
      <DupFlowStepOne {...props} />
    </Route>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step2Path.value}`}>
      <DupFlowStepTwo {...props} />
    </Route>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step3Path.value}`}>
      <DupFlowStepThree {...props} />
    </Route>
    <Route exact path={`/${PORTALTHIRD_BASE_URL}/${props.fields.Step4Path.value}`}>
      <DupFlowStepFour {...props} />
    </Route>
  </Switch>
);

export default DupFlow;
